import { render, staticRenderFns } from "./hezi.vue?vue&type=template&id=d5a9958a&"
import script from "./hezi.vue?vue&type=script&lang=js&"
export * from "./hezi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports